"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CompanySDK = require('@nackle/company-sdk');
function CompanyService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  const companySdk = CompanySDK(_endpoints.companyURL, fetch);
  async function listCompanies() {
    return await cache('listCompanies', async () => {
      const data = await companySdk.getCompanies();
      return data.companyList.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  async function getCompany(companyId) {
    return await cache('getCompany', async () => {
      const company = await companySdk.getCompany(companyId);
      return company;
    })();
  }
  async function listCountries(companyId) {
    return await cache(`listCountries:${companyId}`, async () => {
      const company = await getCompany(companyId);
      if (!company) {
        return null;
      }
      return company.countryList.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  return {
    listCompanies,
    getCompany,
    listCountries
  };
}
var _default = exports.default = CompanyService;
//# sourceMappingURL=company.js.map